import React from 'react'

export default class IntervalPicker extends React.Component {
  static secondsToInterval(num) {
    const map = {
      300: '5m', 900: '15m', 1800: '30m',
      // 3600: '1h',
      7200: '2h', 14400: '4h', 86400: '1d'
    }
    return map[num]
  }

  static intervalToSeconds(text) {
    // poloniex doesn't support 1h interval
    // valid values are 300, 900, 1800, 7200, 14400, and 86400
    const map = {
      '5m': 300, '15m': 900, '30m': 1800,
      // '1h': 3600,
      '2h': 7200, '4h': 14400, '1d': 86400
    }
    return map[text]
  }

	choices = (arr) => {
		return arr.map((val, idx) => {
			return (<li key={idx} className=''>
				<a href="#interval" className='f5 db pa1 link hover-dark-red'
					onClick={() => this.props.onSelect( IntervalPicker.intervalToSeconds(val) )}>
					{val}
				</a>
			</li>)
		})
	}

  render() {
  	var periods = ['5m', '15m', '30m', '2h', '4h', '1d']

    return (
      <div className='absolute interval-picker z-index-100 shadow-2'>
        <div className='w-100'>
          <button className='bg-animate' onClick={this.props.onCancel}>Cancel</button>
        </div>
        <div className='w-100 pa2 center'>
          Set interval for all charts. 
        </div>
        <div className='w-50 pa1 center'>
          <ul className='list pl0 ma0 br2'>
          	{ this.choices(periods) }
          </ul>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/IntervalPicker.js